const DeleteOutlineIcon = ({ className }) => (
  <svg
    aria-hidden='true'
    className={className}
    height='20'
    viewBox='10 10 20 20'
    fill='none'
    width='20'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M25.7143 16.6667V27.7778H14.2857V16.6667H25.7143ZM23.5714 10H16.4286L15 11.1111H10V13.3333H30V11.1111H25L23.5714 10ZM28.5714 14.4444H11.4286V27.7778C11.4286 29 12.7143 30 14.2857 30H25.7143C27.2857 30 28.5714 29 28.5714 27.7778V14.4444Z'
      fill='currentColor'
    />
  </svg>
)

export default DeleteOutlineIcon
